export enum UserStatusValues {
  Active = "A",
  Deactivated = "D",
  LockedOut = "LO",
  PasswordExpired = "PE",
  PasswordReset = "PR",
  PendingUserAction = "PUA",
  Suspended = "S",
  Staged = "ST"
}
